// ---------------------------------------------------------------------------
// Light / dark mode.
//
// The theme is a single attribute on <html>:  data-theme="dark" | "light".
// styles/theme-light.css re-points the colour variables when it is "light".
// The choice is saved in the browser (localStorage) and switches instantly,
// no page reload.
// ---------------------------------------------------------------------------

const STORAGE_KEY = 'app_theme';
export const DEFAULT_THEME = 'dark';

export function getTheme() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'light' || saved === 'dark' ? saved : DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function setTheme(theme) {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    /* storage blocked: the theme still changes for this visit */
  }
  applyTheme(theme);
}
